import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Document from '../../../components/document';
import { getDocuments } from '../../../reducers/documents';
import { employeeHandBook } from '../../../utilities/regime';

class ContractorPolicyDocs extends React.Component {
    render() {
        const { admin, globalDocuments, regime } = this.props;
        if (!globalDocuments) {
            return null;
        }

        return (
            <div className="row">
                <div className="col-xs-12">
                    <Document {...employeeHandBook(regime)} ownerRole={{ id: admin.id, type: 'admin' }} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const role = state.identity.role;
    const prop = `${role.id}-all`;
    let documents = state.documents[prop];
    if ((documents || {}).list) {
        documents.list = documents.list.filter(d => !['never', 'later'].includes(d.status));
    }
    return {
        role,
        admin: state.users.adminDetails,
        globalDocuments: documents ? documents.list : undefined,
        regime: (state.jobs.list || [{}])[0].regime
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getDocuments
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorPolicyDocs);



// WEBPACK FOOTER //
// ./src/pages/documents/tabs/contractorPolicyDocs.jsx